<template>
    <div class="d-flex align-items-center">
        <input
            v-if="currentValue === null"
            maxlength="3"
            name="qty"
            :rel="`ajax_id_combination_${idProductAttribute}`"
            :id="isMobile ? `count_${idProduct}_${idProductAttribute}_mobile` : `count_${idProduct}_${idProductAttribute}`"
            :value="maxAmount"
            class="algolia-listing-product-block__quantity-select"
            type="number"
        />
        <div
            v-else
            class="algolia-listing-product-block__quantity-select-wrapper"
        >
            <select
                maxlength="3"
                name="qty"
                v-model="currentValue"
                :rel="`ajax_id_combination_${idProductAttribute}`"
                :id="isMobile ? `count_${idProduct}_${idProductAttribute}_mobile` : `count_${idProduct}_${idProductAttribute}`"
                class="algolia-listing-product-block__quantity-select"
            >
                <option v-for="i in maxAmount" :value="i">{{ i }} </option>
                <option :value="null">
                    {{ $t("algoliaSearch.refinementListViewMore") }}
                </option>
            </select>
        </div>
    </div>
</template>

<script>
export default {
    name: "AmountInput",
    props: {
        idProduct: {
            type: [String, Number],
            required: true
        },
        idProductAttribute: {
            type: [String, Number],
            default: 0,
        },
        maxAmount: {
            type: Number,
            default: 5
        },
        isMobile: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            currentValue: 1
        };
    }
};
</script>
